import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import {
  ApiResponse,
  ProviderInvitationInfo,
  ProviderRegistrationResult,
  RegisterProviderRequest,
} from '@core/types';

@Injectable({
  providedIn: 'root',
})
export class ProviderRegistrationService {
  private readonly baseUrl = `${environment.api}/provider-register`;

  constructor(private httpClient: HttpClient) {}

  validateInvitation(code: string): Observable<ApiResponse<ProviderInvitationInfo>> {
    return this.httpClient
      .post<ApiResponse<ProviderInvitationInfo>>(`${this.baseUrl}/validate-invitation`, { code })
      .pipe(
        catchError((errorResponse: HttpErrorResponse) =>
          throwError(() => `${errorResponse.error.message}`)
        )
      );
  }

  complete(item: RegisterProviderRequest): Observable<ApiResponse<ProviderRegistrationResult>> {
    return this.httpClient
      .post<ApiResponse<ProviderRegistrationResult>>(`${this.baseUrl}/complete`, item)
      .pipe(
        catchError((errorResponse: HttpErrorResponse) =>
          throwError(() => `${errorResponse.error.message}`)
        )
      );
  }
}
